import { ArrowDownSvg } from 'components/top/extend/svg/arrow-down'
import { ComponentPropsWithoutRef } from 'react'

export function BlackButton({
  style,
  children,
  ...more
}: ComponentPropsWithoutRef<'button'>) {
  return (
    <button
      type='button'
      className='outline-none w-full bg-[#494949] rounded-full flex items-center justify-center h-[48px] relative'
      style={{ boxShadow: '0px 4px 0px 0px #000', ...style }}
      {...more}
    >
      <span className='text-[16px] leading-[32px] tracking-[1.6px] font-semibold text-white'>
        {children}
      </span>
      <ArrowDownSvg className='w-[24px] h-[24px] transform -rotate-90 absolute right-[24px] text-primary-600' />
    </button>
  )
}
